<template>
  <div class="home">
    <van-nav-bar title="兽药储存" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed/>
    <van-nav-bar title="兽药储存" v-else fixed/>
    <div class="navheight"></div>
    <!-- <van-search v-model="value" show-action placeholder="请输入关键字进行搜索" @search="onSearch">
      <template #action>
        <div v-if="value.length>0" @click="onCancel">清空</div>
      </template>
    </van-search> -->
    <van-collapse v-model="activeNames">
      <van-collapse-item title="1、进场消毒"  name="1">
        <div class="content">
          <p class="text">进场兽药必须保留相应说明书，必须经消毒剂消毒外包装才可登记进场，转运至存放药品专用库房。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="2、依照说明书要求的保存条件放置兽药" name="2">
        <div class="content">
          <p><span>防潮：</span>装药的包装和容器应当密闭，如是瓶装必须盖紧，必要时用蜡封口。 </p>
          <p><span>避光：</span>有些药物遇光后性质会改变，药效降低，甚至变成有害的有毒物质，可采用棕色瓶或用黑色纸包裹的玻璃器包装，以防止紫外线的透入并存放在阴凉干燥、光线不易直射到的地方。禁止更换原装兽药瓶，应以原瓶保存。</p>
          <p><span>温度适宜：</span>温度过高或过低都能使某些兽药变质。例如很多抗生素类注射液需要在冷藏条件下保存，这就需要仔细阅读说明书进行运输和存放。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="3、注意药品保质期，不定期清理过期兽药" name="3">
        <div class="content">
          <p>兽药应分期、分批储存，并设立专门卡片，以防过期失效。如发现储存的兽药超过保质期，应及时处理和更换，并补充经常使用的新药，避免使用超过保质期的兽药。对过期或变质兽药应彻底销毁。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="4、避免混放" name="4">
        <div class="content">
          <p>将兽药储存仓库分隔，例如不同种类抗生素分区标记存放，内用药和外用药分开存放，特别注意消毒、杀虫、驱虫药物、农药、鼠药等危险药物不应与普通兽药混放，最好放置在不易接触的封闭区域。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="5、防止鼠咬和虫蛀" name="5">
        <div class="content">
          <p>对采用纸盒、纸袋、塑料袋等包装的兽药，储存时要放在其他密闭的容器中，以防止鼠咬及虫蛀。</p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <!-- <div class="footer-center">
      <p>参考资料:《中华人民共和国兽药典》2015年版一部</p>
    </div> -->
    <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
import { searchHighlight } from '@/utils/utils.js'
import Top from '@/components/top.vue'
// import { shopCombination } from '@/api/resetApi.js'

export default {
  name: 'pigfarm',
  components: { Top },
  data() {
    return {
      btnFlag:false,
      value:'',
      activeNames: ['1'],
      isWx:1,
    };
  },
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
    onSearch() {
      this.activeNames = ['1','2','3','4','5']
      let val = this.value
      setTimeout(function (){
        searchHighlight(val)
      }, 100);
    },
    onCancel() {
      this.value = ''
    }
  },
}
</script>

<style lang="scss">
  @import '../../assets/style/knowledge.scss';
</style>
